import axiosHttp from './axios';
import config from '../../config';
import {authconfig} from '../shared/utils/common';
import { errorOccuredAndLogged_Mixpanel } from '../shared/mixpanel/mixpanel';
import { CONNECTIVITY_ISSUE, NETWORK_ISSUE, NETWORK_ERROR, PAYOUT_SUMMARY_API,PAYOUT_BY_ORDER_HISTORY_API, PAYOUT_HISTORY_API } from '../constants/mixPannelConstants';

export const makePayoutSummaryCall = async(action)=> {
	let configs = authconfig(config.env, 'order');
	const {startDate , endDate, merchantId, storeID } = action.payload ;
	let url = process.env.ORDER_SERVICE_API+`/orders/merchant/payments/summary?startDate=${startDate}&endDate=${endDate}&merchantId=${merchantId}`;

	if ( storeID.length > 0 ) {
		url = process.env.ORDER_SERVICE_API+`/orders/merchant/payments/summary?startDate=${startDate}&endDate=${endDate}&merchantId=${merchantId}&stores=${storeID}`;
	}

	try {
		if (startDate !=null && endDate !=null){
			const response = await axiosHttp.get(url, configs);
			return response.data;
		}
	} catch (error) {
		//console.error(error);
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, PAYOUT_SUMMARY_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, PAYOUT_SUMMARY_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}


export const makePayoutHistoryCall = async(action)=> {
	let configs = authconfig(config.env, 'order');
	const {startDate , endDate, merchantId, searchTerm, data } = action.payload ;
	let url = process.env.ORDER_SERVICE_API+`/merchants/${merchantId}/payouts?startDate=${startDate}&endDate=${endDate}`;
	if (searchTerm) {
		url = process.env.ORDER_SERVICE_API+`/merchants/${merchantId}/payouts?startDate=${startDate}&endDate=${endDate}&storeId=${searchTerm}&isSearch=true`;
	}

	try {
		if (startDate !=null && endDate !=null){
			const response = await axiosHttp.post(url, data, configs);
			return response.data;
		}
	} catch (error) {
		if (!(error?.response?.data?.errorMessage === 'No data found for given merchant/stores')) {
			errorOccuredAndLogged_Mixpanel(error, PAYOUT_HISTORY_API, CONNECTIVITY_ISSUE);
		} else if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, PAYOUT_HISTORY_API, NETWORK_ISSUE);
		}
		return error;
	}
}

export const makePayoutByOrderHistoryCall = async(action)=> {
	let configs = authconfig(config.env, 'order');
	const {startDate , endDate, merchantId, searchTerm, data } = action.payload ;
	let url = process.env.ORDER_SERVICE_API+`/merchants/${merchantId}/orders?startDate=${startDate}&endDate=${endDate}`;
	if (searchTerm) {
		url = process.env.ORDER_SERVICE_API+`/merchants/${merchantId}/orders?startDate=${startDate}&endDate=${endDate}&merchantOrderId=${searchTerm}&isSearch=true`;
	}

	try {
		if (startDate !=null && endDate !=null){
			const response = await axiosHttp.post(url, data, configs);
			return response.data;
		}
	} catch (error) {
		if (!(error?.response?.data?.errorMessage === 'No data found for given merchant/stores')) {
			errorOccuredAndLogged_Mixpanel(error, PAYOUT_BY_ORDER_HISTORY_API, CONNECTIVITY_ISSUE);
		} else if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, PAYOUT_BY_ORDER_HISTORY_API, NETWORK_ISSUE);
		}
		return error;
	}
}
